import { svg } from "../svg";

// The wordmark text below uses tw-fill-fg-heading, not tw-fill-fg-nav. This logo now
// renders in the app's full-width header bar (see user-layout.component.html), which
// sits OUTSIDE the sidenav's [data-nav-version]-tagged subtree that remaps
// --color-fg-nav for legibility there. Outside that subtree --color-fg-nav falls back
// to its unconditional global value (white), which is invisible on the header bar's
// white background in light mode. --color-fg-heading is not nav-scoped: it tracks the
// general light/dark theme directly (dark navy on light, near-white on dark), matching
// whatever background tw-bg-background gives the header bar in either theme.
//
// IMPORTANT: the svg`...` tag below is one continuous JS template literal — never put
// a backtick character anywhere inside the markup (including in comments), or it will
// prematurely terminate the string and break the build with cascading syntax errors.
const PasswordManagerLogo = svg`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 280 49" fill="none">
    <rect x="0" y="6" width="37" height="37" rx="9" fill="#0066ff"/>
    <path d="M13 22.5v-2a5.5 5.5 0 0 1 11 0v2" fill="none" stroke="#ffffff" stroke-width="2.4" stroke-linecap="round"/>
    <rect x="9.5" y="22" width="18" height="13" rx="2.5" fill="#ffffff"/>
    <circle cx="18.5" cy="28.5" r="1.6" fill="#0066ff"/>
    <text x="47" y="31" font-family="Inter, 'Segoe UI', Arial, sans-serif" font-size="19" font-weight="600" class="tw-fill-fg-heading">Vault Prolinkdigital</text>
  </svg>
`;

export default PasswordManagerLogo;
